import React from 'react';
import BuyButton from './BuyButton';

import gorodImg from './img/gorod-logo-2x.png';
import bukvoedImg from './img/bukvo_logo-x2.png';
import panda396Img from './img/friday-panda_396-x2.png';
import pandaTVImg from './img/panda-in-tv-x2.png';

import './BlockTitle.scss';
import Sticker from './Sticker';

const BlockTitle: React.FC = () => {
    return (
        <div className="block-title">
            <div className="title">
                <div className='title-text'>
                    <p className='p1'>Панда<br/>Фрайди</p>
                    <p className='p2'>Ищи мягкую игрушку<br/>в сети книжных магазинов</p>
                    <div className='row logos-wrapper'>
                        <div className='col-7'>
                            <a href="https://www.chitai-gorod.ru/product/myagkaya-igrushka-panda-fraydi-35-sm-2978936?utm_source=+landing&utm_medium=social&utm_campaign=+Friday">
                                <img className='w-100' src={gorodImg} alt='Читай Город' />
                            </a>
                        </div>
                        <div className='col-5'>
                            <a href="https://www.bookvoed.ru/book?id=13609732&utm_source=friday.ru&utm_medium=partners&utm_campaign=panda_friday">
                                <img className='w-100' src={bukvoedImg} alt='Буквоед' />
                            </a>
                        </div>
                    </div>
                </div>
                <BuyButton
                    url='https://www.chitai-gorod.ru/product/myagkaya-igrushka-panda-fraydi-35-sm-2978936?utm_source=+landing&utm_medium=social&utm_campaign=+Friday'
                    className='mt-5 d-none d-md-block w-75 mx-auto' 
                />
                <Sticker rotate={-5} />
                <img className="panda-tv" src={pandaTVImg} alt="" />
            </div>
            
            <div className='panda-396-box'>
                <img className="panda-396" src={panda396Img} alt="" />    
            </div>
            
            <div className="text-center button-box d-block d-md-none">
                <BuyButton 
                    url='https://www.chitai-gorod.ru/product/myagkaya-igrushka-panda-fraydi-35-sm-2978936?utm_source=+landing&utm_medium=social&utm_campaign=+Friday'
                />
            </div>
        </div>
    );
};

export default BlockTitle;